import React, { useEffect, useState } from "react";
import { Col, Form, Input, message, Row, Select, TimePicker } from "antd";
import { useDispatch } from "react-redux";
import map from "lodash/map";
import get from "lodash/get";
import dayjs from "dayjs";

import { fetchCompanyStaffs } from "../../redux/actions/companyActions";
import { updateCompanyTemplate } from "../../redux/actions/templateActions";
import { UPDATE_TEMPLATE_SUCCESS } from "../../constants/message";

const EditTemplate = ({
  config,
  setLoading,
  initialValues,
  form,
  toggleTemplateForm,
  refresh,
}) => {
  const [staffs, setStaffs] = useState([]);
  const dispatch = useDispatch();
  const getCompanyStaff = (company_uuid) => {
    setLoading(true);
    dispatch(fetchCompanyStaffs(company_uuid, { role_id: 1 }))
      .then((result) => {
        setLoading(false);
        setStaffs(result);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    setLoading(true);
    const payload = {
      company_id: get(values, "company_id"),
      manager_uuid: get(values, "manager_uuid"),
      name: get(values, "name"),
    };
    dispatch(
      updateCompanyTemplate(
        get(values, "company_id"),
        get(initialValues, "id"),
        payload,
      ),
    )
      .then(() => {
        setLoading(false);
        message.success(UPDATE_TEMPLATE_SUCCESS);
        refresh();
        toggleTemplateForm();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        company_id: get(initialValues, "company.id"),
        type_id: get(initialValues, "type.value"),
        reset_time: dayjs(get(initialValues, "reset_time"), "HH:mm"),
        manager_uuid: get(initialValues, "manager.id"),
        name: get(initialValues, "name"),
      });
      getCompanyStaff(get(initialValues, "company.id"));
    }
  }, [initialValues]);

  return (
    <div>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Row gutter={16}>
          <Col xs={12}>
            <Form.Item
              label="Company"
              name="company_id"
              rules={[
                {
                  required: true,
                  message: "Please select Company",
                },
              ]}
            >
              <Select
                options={map(get(config, "companies"), (company) => ({
                  label: get(company, "name"),
                  value: get(company, "id"),
                }))}
                disabled
                placeholder="Company Name"
              />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item
              label="Machine Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please input Machine Name",
                },
              ]}
            >
              <Input placeholder="Machine Name" />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item
              label="Template"
              name="type_id"
              rules={[
                {
                  required: true,
                  message: "Please select Template...!",
                },
              ]}
            >
              <Select
                options={map(
                  Object.values(get(config, "template_types.templates", {})),
                  (template) => ({
                    label: get(template, "name"),
                    value: get(template, "value"),
                  }),
                )}
                style={{ width: "100%" }}
                disabled
                placeholder="Select Template"
              />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item
              name="reset_time"
              label="Reset Time"
              rules={[
                {
                  required: true,
                  message: "Please select Reset time...!",
                },
              ]}
            >
              <TimePicker
                className="w-full"
                format={"HH:mm"}
                minuteStep={15}
                disabled
                defaultOpenValue={dayjs("08:00:00", "HH:mm:ss")}
              />
            </Form.Item>
          </Col>
          <Col xs={12}>
            <Form.Item
              label="Staff Manager"
              name="manager_uuid"
              rules={[
                {
                  required: true,
                  message: "Please select Staff Manager",
                },
              ]}
            >
              <Select
                placeholder="Staff Manager"
                optionFilterProp="label"
                showSearch
                options={map(staffs, (staff) => ({
                  label: get(staff, "name"),
                  value: get(staff, "id"),
                }))}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default EditTemplate;
